import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import hr from "./locales/hr.json";
import en from "./locales/en.json";
import de from "./locales/de.json";

export const LANGS = [
  { code: "hr", label: "HR", name: "Hrvatski" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
];

const stored = typeof window !== "undefined" ? window.localStorage.getItem("lang") : null;
const initialLang = LANGS.some((l) => l.code === stored) ? stored : "hr";

i18n.use(initReactI18next).init({
  resources: {
    hr: { translation: hr },
    en: { translation: en },
    de: { translation: de },
  },
  lng: initialLang,
  fallbackLng: "hr",
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") document.documentElement.lang = initialLang;

i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") window.localStorage.setItem("lang", lng);
  if (typeof document !== "undefined") document.documentElement.lang = lng;
});

export default i18n;
